import { useSelector } from "react-redux";
import { useMemo } from "react";

export const useHasPermission = () => {
    const { user, session, extraModules } = useSelector((state) => state.auth);
    const { tiny_name: campus } = useSelector((state) => state.config);
    const isLogged = !!user;

    const hasPermission = useMemo(() => {
        return (permissions = []) => {
            if (!isLogged) {
                console.error(
                    "Hook useHasPermission: hasPermission",
                    "Debes iniciar sesión."
                );
                return false;
            }

            const { modules } = user;

            let permissionsArray = [];

            if (typeof permissions === "string") {
                permissionsArray.push(permissions);
            } else {
                if (typeof permissions === "object") {
                    permissionsArray = permissions;
                } else {


                    console.error(
                        "Hook useHasPermission:",
                        "Debes pasar un ´array´ o un ´string´"
                    );
                    return false;
                }
            }

            const modules_code = modules.map((m) => m.code);

            for (let i = 0; i < modules_code.length; i++) {
                for (let j = 0; j < permissionsArray.length; j++) {
                    if (modules_code[i] === permissionsArray[j]) {
                        return true;
                    }
                }
            }
            return false;
        };
    }, [isLogged, user]);

    const hasExtraModule = useMemo(() => {
        return (permissions = []) => {
            if (!isLogged) {
                console.error(
                    "Hook useHasPermission: hasExtraModule",
                    "Debes iniciar sesión."
                );
                return false;
            }

            // Normaliza a array de strings
            let permissionsArray = [];
            if (typeof permissions === "string") {
                permissionsArray = [permissions];
            } else if (Array.isArray(permissions)) {
                permissionsArray = permissions;
            } else {
                console.error(
                    "Hook useHasPermission:",
                    "Debes pasar un ´array´ o un ´string´"
                );
                return false;
            }

            // Si extraModules no es un objeto válido, no hay módulos extra disponibles
            if (!extraModules || typeof extraModules !== "object") {
                return false;
            }

            // Obtiene solo los módulos extra activos (true)
            const extraModulesCodes = Object.entries(extraModules)
                .map(([module, access]) => (access ? module : null))
                .filter(Boolean);

            // Retorna true si hay al menos una coincidencia
            return permissionsArray.some((permission) =>
                extraModulesCodes.includes(permission)
            );
        };
    }, [isLogged, extraModules]);

    return { hasPermission, hasExtraModule, isLogged, session, campus };
};
